module.exports = __webpack_public_path__ + "static/media/roshan.5ce1d2e1.jpg";